import { ManageMyTeamCTA } from "./ctas";
export var ManageTeamsIA = function ManageTeamsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MANAGE_YOUR_TEAM(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MEMBERS_OF_YOUR_TEAM(strictLocalize), TO_CREATE_OR_MANAGE_YOUR_TEAM(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ManageMyTeamCTA(strictLocalize);
};
var MANAGE_YOUR_TEAM = function MANAGE_YOUR_TEAM(strictLocalize) {
  return strictLocalize({
    id: "NjuaWu",
    defaultMessage: [{
      "type": 0,
      "value": "Gérez votre équipe"
    }]
  });
};
var MEMBERS_OF_YOUR_TEAM = function MEMBERS_OF_YOUR_TEAM(strictLocalize) {
  return strictLocalize({
    id: "+yGnWb",
    defaultMessage: [{
      "type": 0,
      "value": "Les membres de votre équipe ont chacun leurs propres identifiants pour accéder à votre compte Faire. Vous pouvez ainsi collaborer plus efficacement, simplifier la communication concernant vos commandes et gérer les rôles et les autorisations des membres de votre équipe."
    }]
  });
};
var TO_CREATE_OR_MANAGE_YOUR_TEAM = function TO_CREATE_OR_MANAGE_YOUR_TEAM(strictLocalize) {
  return strictLocalize({
    id: "FHtHSw",
    defaultMessage: [{
      "type": 0,
      "value": "Pour créer ou gérer votre équipe, gérer les autorisations et la propriété du compte, cliquez sur le bouton ci-dessous ou consultez l'article du Centre d'aide pour en savoir plus. Vous pouvez nous contacter si vous avez besoin d'aide."
    }]
  });
};